import gridView from 'components/gridView';
import landscapeCarousel from 'components/landscapeCarousel';
import bindScroll from 'helpers/bindScroll';

export default function gridAndCarousels(moreEpisodesEndpoint, carouselsEndpoint) {
    try {
        gridView({
            parentContainer: $('#latest-episodes'),
            options: {
                endPoint: moreEpisodesEndpoint,
            },
        });
    } catch (e) {
        console.error('Full Episodes grid failed to load');
    }

    try {
        let carousels = $('.js-video-carousel');
        let objs = [];

        for (var i = 0; i < carousels.length; i++) {
            let wrapper = $(carousels[i]);
            objs.push({
                wrapper: wrapper,
                init: function () {
                    wrapper.on('init', () => {
                        wrapper.removeClass('hidden');
                    });

                    wrapper.on('setPosition', () => {
                        wrapper.ellipsify();
                    });

                    if (wrapper.data('topic')) {
                        landscapeCarousel({
                            parentContainer: wrapper,
                            options: {
                                endPoint:
                                    '/shows/{slug}/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/xs/0/topic/{topic}/',
                                params: {
                                    slug: wrapper.data('slug'),
                                    sectionId: wrapper.data('sectionid'),
                                    topic: wrapper.data('topic'),
                                },
                            },
                        });
                    } else {
                        // START A/B TEST PLGRWEB-1653 : Numeric Carousel for Iconic Episodes
                        let numericEpisodes = wrapper.data('numeric-episodes') ?? null;
                        let setNumericStyle = numericEpisodes ? '?numeric=true' : '';
                        // END A/B TEST PLGRWEB-1653 : Numeric Carousel for Iconic Episodes

                        landscapeCarousel({
                            parentContainer: wrapper,
                            options: {
                                endPoint:
                                    carouselsEndpoint +
                                    // START A/B TEST PLGRWEB-1653 : Numeric Carousel for Iconic Episodes
                                    setNumericStyle,
                                // END A/B TEST PLGRWEB-1653 : Numeric Carousel for Iconic Episodes
                                params: {
                                    slug: wrapper.data('slug'),
                                    sectionId: wrapper.data('sectionid'),
                                },
                            },
                        });
                    }
                },
            });
        }

        new bindScroll(objs);
    } catch (e) {
        console.error('below the fold carousel failed to load', e);
    }
}
